import { Strings } from "../../resources/i18n/i18n";

export const FIRST_ROW_COLUMNS = [
    { key: "mid", name: "minimartId" },
    { key: "mn", name: "minimartName" },
    { key: "sp", name: "SALES_PERSON" },
    // { key: "rs", name: "reason" },
    // { key: "action", name: "action" },
];

export const LOAN_STATUSES = {
    PENDING: "PENDING",
    VISITED: "VISITED",
    DISMISSED: "DISMISSED",
    ASSIGNED: "ASSIGNED",
};

// Report download URL, appended to API.getReports ("/reports") by dowloadedAction,
// i.e. POST /reports/whatsapp/interests/download (ReportDownloadController).
// The endpoint reads every filter as a @RequestParam, so downloadFile() builds the
// full query string (fileType, st, sp, mid, fd, td) rather than sending a body.
export const WHATSAPP_INTEREST_REPORT_DOWNLOAD = {
    downloadUrl: "/whatsapp/interests/download",
};

export const LOAN_REQUEST_STATUSES = [
    { name: Strings("PENDING"), value: LOAN_STATUSES.PENDING },
    { name: Strings("VISITED"), value: LOAN_STATUSES.VISITED },
    { name: Strings("DISMISSED"), value: LOAN_STATUSES.DISMISSED },
    { name: Strings("ASSIGNED"), value: LOAN_STATUSES.ASSIGNED },
];

export const SECOND_ROW_COLUMNS = [
    { key: "amt", name: "amount" },
    { key: "lt", name: "loanType" },
    { key: "term", name: "Term" },
    { key: "rt", name: "rate" },
    { key: "btn", name: "dismiss" },
    { key: "emi", name: "emi" },
    { key: "cd", name: "RequestDate" },
    { key: "nt", name: "Note" },
    { key: "dby", name: "dismissedBy" },
    { key: "dat", name: "dismissedAt" },
];
export const WHATSAPP_TABS = [
    { key: "whatsappInterest", label: Strings("whatsappInterest"), value: "WHATSAPP_INTEREST" },
    { key: "minimart", label: Strings("Minimart"), value: "WHATSAPP_MINIMART_LIST" },
];
export const WHATSAPP_TAB_NAMES = {
    WHATSAPP_INTEREST: "WHATSAPP_INTEREST",
    WHATSAPP_MINIMART_LIST: "WHATSAPP_MINIMART_LIST"
}
export const BUSINESS_TYPE = [
    {
        key: 0,
        value: Strings("BusinessType"),
        label: Strings("BusinessType"),
    },
];
export const WHATSAPP_MINIMART_LIST_COLUMNS = [
    { key: "id", name: "minimartId", width: "10%" },
    { key: "code", name: "minimartCode", width: "15%" },
    { key: "name", name: "minimartName", width: "35%" },
    { key: "branch", name: "Branch", width: "20%" },
    { key: "ownerPhone", name: "PhoneNumber", width: "10%" },
    { key: "action", name: "action", width: "10%" }
];
export const IS_WHATSAPP_NUMBER = [
    {
      key: 0,
      value: "AllMinimarts",
      label: Strings("whatsappNumber"),
    },
    {
      key: 1,
      value: "true",
      label: Strings("whatsappNumberAvailable"),
    },
    {
      key: 2,
      value: "false",
      label: Strings("noWhatsappNumber"),
    },
  ]
